// extracted by mini-css-extract-plugin
export var layoutContainer = "_de-0";
export var layoutContainerNoRounding = "_de-6";
export var layoutContainerOpen = "_de-5";
export var layoutContainerResizing = "_de-1";
export var mainContent = "_de-2";
export var resizeDivider = "_de-3";
export var slidePanel = "_de-4";